<template>
    <div class="section has-text-primary-15">
        <div class="container">
          <router-view/>
        </div>
    </div>
</template>